import { createAsyncThunk } from "@reduxjs/toolkit";
import { userId } from "src/helpers/user_id";
import { apiClient } from '../../helpers/api_helper';

function calculateDuration(startDate: string, endDate: string): number {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const duration = Math.floor(
    (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)
  );
  return duration;
}

export const getProjects: any = createAsyncThunk("project/getProjects",async () => {
    try {
      const response = await apiClient.get(`/project/projects/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addProject = createAsyncThunk("project/addProject",async (project: any) => {
    try {
      const response = await apiClient.post(`/project/projects/`, {
          nome: project.nome,
          descricao: project.projectDesc,
          duracao: calculateDuration(project.dataInicio, project.prazoPrevisto),
          proveniencia_fundo: project.provenienciaFundo,
          data_termino: project.prazoPrevisto,
          valor_previsto: project.valorPrevisto,
          unidade: Number(project.team),
          data_inicio: project.dataInicio,
          objectives: project.objectives,
          financiador: Number(project.financiador),
          project_descricao: project.projectDesc,
          responsaveis: project.responsibles,
          create_user: userId,
          update_user: userId,
        }        
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const updateProject = createAsyncThunk("project/updateProject", async (project: any) => {
    try {
      const response = await apiClient.put(`/project/projects/${project.id}/`,{
          nome: project.nome,
          valor_previsto: project.valor_previsto,
          unidade: project.unidade_id.value,
          duracao: calculateDuration(project.data_inicio, project.data_termino),
          proveniencia_fundo: project.proveniencia_fundo,
          data_inicio: project.data_inicio,
          data_termino: project.data_termino,
          data_real_termino: project.data_real_termino,
          create_user: userId,
          update_user: userId,
          descricao: project.project_descricao,
          responsaveis: project.responsibles,
          status: project.status,
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const deleteProject = createAsyncThunk("project/deleteProject", async (projectId: any) => {
    try {
      const response = await apiClient.delete(`/project/projects/${projectId}/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getProjectById = createAsyncThunk("project/getProjectById",async (projectId: string) => {
    try {
      const response = await apiClient.get(`/project/projects/${projectId}/get-project-by-id/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getProjectFinanciers = createAsyncThunk("financing/getProjectFinanciers", async (projectId: any) => {
    try {
      const response = await apiClient.get(`/project/projects/${projectId}/financiers/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addAttachments = createAsyncThunk("project/addAttachments", async ({ projectId, attachments }: { projectId: any, attachments: File[] }) => {
    try {
      const formData = new FormData();

      attachments.forEach((file, index) => {
        formData.append(`files[${index}]`, file);
      });
      const response = await apiClient.post(`/project/projects/${projectId}/attachments/`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data' 
        }
      });
      
      return response;

    } catch (error) {
      return error;
    }
  }
);

export const getAttachments = createAsyncThunk("project/getAttachments", async (projectId: number) => {
    try {
      console.log('Project ID', projectId);
      const response = await apiClient.get(`/project/projects/${projectId}/attachments/`);      
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const deleteAttachment = createAsyncThunk("attachment/deleteAttachment", async (attachmentId: number) => {
    try {
      const response = await apiClient.delete(`/project/attachments/${attachmentId}/`);
      return response;
    } catch (error) {
      return error;
    }
  }
);